package ai.flowstorm.studio.resources.space

import ai.flowstorm.common.id.Id
import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.studio.model.Initiation
import ai.flowstorm.common.resources.EntityResource
import ai.flowstorm.studio.model.TesterResult
import kotlinx.serialization.builtins.ListSerializer

object InitiationResource : EntityResource<Initiation>(serializer = Initiation.serializer()) {

    override val resourceUri: String
        get() = "/spaces/${AppState.state.spaceId!!.value}/initiations"

    suspend fun rerun(initiationId: Id) {
        remoteCall<Unit>(client.baseUrl + "/initiations/${initiationId.value}/rerun")
    }

    suspend fun groups(initiationId: String): List<TesterResult> {
        return remoteCall(client.baseUrl + "/initiations/${initiationId}/groups", deserializer = ListSerializer(TesterResult.serializer()))
    }
}
